'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = require('preact');

var _functional = require('../../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-unused-vars
var PushComplimentary = function (_Component) {
  (0, _inherits3.default)(PushComplimentary, _Component);

  function PushComplimentary() {
    (0, _classCallCheck3.default)(this, PushComplimentary);
    return (0, _possibleConstructorReturn3.default)(this, (PushComplimentary.__proto__ || Object.getPrototypeOf(PushComplimentary)).apply(this, arguments));
  }

  (0, _createClass3.default)(PushComplimentary, [{
    key: 'triggerModal',
    value: function triggerModal() {
      (0, _functional.getElement)('[data-modal="complimentary"]').classList.add('mod-Modal-active');
    }
  }, {
    key: 'render',
    value: function render(props, state, context) {
      if (this.props.complimentary.enable === 'false' || this.props.subtotal < this.props.complimentary.min_price) {
        return null;
      }

      if (this.props.complimentaryCount === this.props.complimentary.max) {
        var complimentaryModal = (0, _functional.getElement)('[data-modal="complimentary"]');
        if (complimentaryModal) {
          complimentaryModal.classList.remove('mod-Modal-active');
        }
      }

      return (0, _preact.h)(
        'div',
        {
          className: 'crt-Push_Complimentary',
          onClick: this.triggerModal,
          'aria-hidden': this.props.complimentaryCount === this.props.complimentary.max
        },
        (0, _preact.h)(
          'svg',
          {
            className: 'crt-Push_ComplimentaryIcon crt-Push_ComplimentaryIcon-decorative',
            xmlns: 'http://www.w3.org/2000/svg',
            width: '24',
            height: '25',
            fill: 'none'
          },
          (0, _preact.h)('path', {
            stroke: '#000',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            d: 'M2 24h20V10H2v14ZM1 10h22V6H1v4Z',
            'clip-rule': 'evenodd'
          }),
          (0, _preact.h)('path', {
            stroke: '#000',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            d: 'M12 6c.459-2.155 2.573-4.605 5.21-4.98C18.34.86 19 1.667 19 2.497c0 .362-.127.694-.34.953l.002-.004C17.29 5.26 12 6 12 6'
          }),
          (0, _preact.h)('path', {
            stroke: '#000',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            d: 'M12 6c-.457-2.155-2.573-4.605-5.209-4.98-1.13-.16-1.79.646-1.79 1.476 0 .362.126.693.34.953l-.002-.004C6.711 5.26 12.001 6 12.001 6'
          })
        ),
        (0, _preact.h)(
          'p',
          { className: 'crt-Push_ComplimentaryText' },
          props.translations.complimentary,
          (0, _preact.h)(
            'span',
            { className: 'crt-Push_ComplimentarySelected' },
            this.props.complimentaryCount,
            '/',
            props.complimentary.max,
            ' ',
            props.translations.selected
          )
        ),
        (0, _preact.h)(
          'svg',
          {
            className: 'crt-Push_ComplimentaryIcon',
            width: '20',
            height: '21',
            viewBox: '0 0 20 21',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg'
          },
          (0, _preact.h)('rect', { y: '10', width: '20', height: '1', fill: 'black' }),
          (0, _preact.h)('rect', {
            x: '9.5',
            y: '20.5',
            width: '20',
            height: '1',
            transform: 'rotate(-90 9.5 20.5)',
            fill: 'black'
          })
        )
      );
    }
  }]);
  return PushComplimentary;
}(_preact.Component);

exports.default = PushComplimentary;